import { useQuery } from '@tanstack/react-query';

import { SCIApi, selfCheckInRoute } from 'src/apis';
import { GetRentalLocationOperatingHoursResponse, useGetRentalLocationOperatingHoursReturn } from 'src/types/Calendar';
import { convertMilitaryTimeTo12Hours } from 'src/utils/DateHelper';

const rentalOperatingHoursQueryKey = 'rental-operating-hours';
const selfCheckInLocationOperatingHoursRoute = `${selfCheckInRoute}/points/operating-hours`;

export const useGetRentalLocationOperatingHours = (): useGetRentalLocationOperatingHoursReturn => {
  const { data: operatingHours, isLoading } = useQuery({
    queryKey: [rentalOperatingHoursQueryKey],
    queryFn: getRentalLocationOperatingHours,
  });

  return {
    isLoading,
    operatingHours: {start: {
      open: convertMilitaryTimeTo12Hours(operatingHours?.start?.start),
      close: convertMilitaryTimeTo12Hours(operatingHours?.start?.end),
      rawOpen: operatingHours?.start?.start,
      rawClose: operatingHours?.start?.end,
    }},
  };
};

const getRentalLocationOperatingHours = async (): Promise<GetRentalLocationOperatingHoursResponse> => {
  const axiosResult = await SCIApi.getInstance().get<GetRentalLocationOperatingHoursResponse>(selfCheckInLocationOperatingHoursRoute);
  return axiosResult?.data ?? axiosResult;
};
